import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // The scrollable container is <main id="main-scroll">, not window
    const el = document.getElementById('main-scroll');
    if (el) {
      el.scrollTop = 0;
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}
